import { createAction } from 'redux-actions';

const actions = {
  /**
   * [상품] 상품 데이터 변경하기
   */
  SET_DATA: 'product/SET_DATA',
  setData: createAction('product/SET_DATA'),

  /**
   * [상품 전체 리스트] 상품 전체 리스트 요청하기
   */
  GET_PRODUCT_ALL_LIST_REQUEST: 'product/GET_PRODUCT_ALL_LIST_REQUEST',
  getProductAllList: createAction('product/GET_PRODUCT_ALL_LIST_REQUEST'),

  /**
   * [상품 승인 리스트] 상품 승인 리스트 요청하기
   */
  GET_PRODUCT_APPROVAL_LIST_REQUEST: 'product/GET_PRODUCT_APPROVAL_LIST_REQUEST',
  getProductApprovalList: createAction('product/GET_PRODUCT_APPROVAL_LIST_REQUEST'),

  /**
   * [상품 승인 리스트] 상품 승인 excel 리스트 다운로드 하기
   */
  GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST: 'product/GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST',
  GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_SUCCESS: 'product/GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_SUCCESS',
  getProductApprovalExcelDownload: createAction('product/GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [상품 금지 리스트] 상품 금지 리스트 요청하기
   */
  GET_PRODUCT_BAN_LIST_REQUEST: 'product/GET_PRODUCT_BAN_LIST_REQUEST',
  getProductBanList: createAction('product/GET_PRODUCT_BAN_LIST_REQUEST'),

  /**
   * [상품 금지 리스트] 상품 금지 excel 리스트 다운로드 하기
   */
  GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST: 'product/GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST',
  GET_PRODUCT_BAN_EXCEL_DOWNLOAD_SUCCESS: 'product/GET_PRODUCT_BAN_EXCEL_DOWNLOAD_SUCCESS',
  getProductBanExcelDownload: createAction('product/GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 리스트 요청하기
   */
  GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST: 'product/GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST',
  getProductPropertyRequestList: createAction('product/GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST'),

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 excel 리스트 다운로드 하기
   */
  GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST: 'product/GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST',
  getProductPropertyRequestExcelDownload: createAction('product/GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [상품 리스트] 상품 리스트 받아오기
   */
  GET_PRODUCT_LIST_SUCCESS: 'product/GET_PRODUCT_LIST_SUCCESS',

  /**
   *  [상품 리스트] 태그 검색 리스트 가져오기
   */
  GET_PRODUCT_TAG_LIST_DATA_REQUEST: 'product/GET_PRODUCT_TAG_LIST_DATA_REQUEST',
  getProductTagList: createAction('product/GET_PRODUCT_TAG_LIST_DATA_REQUEST'),

  /**
   *  [상품 리스트] 태그 리스트 가져오기
   */
  GET_PRODUCT_TAG_COLUMN_TAG_LIST_REQUEST: 'product/GET_PRODUCT_TAG_COLUMN_TAG_LIST_REQUEST',
  getProductTagColumnTagList: createAction('product/GET_PRODUCT_TAG_COLUMN_TAG_LIST_REQUEST'),

  /**
   * [상품 상세] 상품 거절 사유 리스트 요청하기
   */
  GET_REJECT_REASON_LIST_REQUEST: 'product/GET_REJECT_REASON_LIST_REQUEST',
  getRejectReasonList: createAction('product/GET_REJECT_REASON_LIST_REQUEST'),

  /**
   * [상품 상세] 사방넷으로 상품 정보 보내기
   */
  SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST: 'product/SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST',
  SEND_PRODUCT_DATA_TO_SABANGNET_SUCCESS: 'product/SEND_PRODUCT_DATA_TO_SABANGNET_SUCCESS',
  sendProductDataToSabangnet: createAction('product/SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST'),

  /**
   * [상품 삭제] 상품 삭제 요청하기
   */
  DELETE_PRODUCT_REQUEST: 'product/DELETE_PRODUCT_REQUEST',
  deleteProduct: createAction('product/DELETE_PRODUCT_REQUEST'),

  /**
   * [상품 등록 승인] 상품 등록 승인 요청하기
   */
  PERMIT_REGISTRATION_PRODUCT_REQUEST: 'product/PERMIT_REGISTRATION_PRODUCT_REQUEST',
  permitRegistrationProduct: createAction('product/PERMIT_REGISTRATION_PRODUCT_REQUEST'),

  /**
   * [상품 등록 거절] 상품 등록 거절 요청하기
   */
  REJECT_REGISTRATION_PRODUCT_REQUEST: 'product/REJECT_REGISTRATION_PRODUCT_REQUEST',
  rejectRegistrationProduct: createAction('product/REJECT_REGISTRATION_PRODUCT_REQUEST'),

  /**
   * [상품 판매 금지 승인] 상품 판매 금지 승인 요청하기
   */
  PERMIT_BAN_PRODUCT_REQUEST: 'product/PERMIT_BAN_PRODUCT_REQUEST',
  permitBanProduct: createAction('product/PERMIT_BAN_PRODUCT_REQUEST'),

  /**
   * [상품 판매 금지] 상품 판매 금지 요청하기
   */
  REJECT_BAN_PRODUCT_REQUEST: 'product/REJECT_BAN_PRODUCT_REQUEST',
  rejectBanProduct: createAction('product/REJECT_BAN_PRODUCT_REQUEST'),

  /**
   * [상품 버전] 상품 버전 정보 요청하기
   */
  GET_PRODUCT_VERSION_INFO_REQUEST: 'product/GET_PRODUCT_VERSION_INFO_REQUEST',
  GET_PRODUCT_VERSION_INFO_SUCCESS: 'product/GET_PRODUCT_VERSION_INFO_SUCCESS',
  getProductVersionInfo: createAction('product/GET_PRODUCT_VERSION_INFO_REQUEST'),

  /**
   * [상품 버전] 상품 버전 상세 요청하기
   */
  GET_PRODUCT_VERSION_DETAIL_REQUEST: 'product/GET_PRODUCT_VERSION_DETAIL_REQUEST',
  GET_PRODUCT_VERSION_DETAIL_SUCCESS: 'product/GET_PRODUCT_VERSION_DETAIL_SUCCESS',
  getProductVersionDetail: createAction('product/GET_PRODUCT_VERSION_DETAIL_REQUEST'),

  /**
   * 엑셀 일괄 상품 할인 변경하기
   */
  EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST: 'product/EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST',
  excelBulkEditProductDiscount: createAction('product/EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST'),

  /**
   * [상품 전체 리스트] 상품 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST: 'product/GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getProductAllListExcelDownload: createAction('product/GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [상품 전체 리스트] 상품 전체 풀필먼트 리스트 엑셀 다운로드 요청하기
   */
  GET_PRODUCT_ALL_FULFILLMENT_LIST_EXCEL_DOWNLOAD_REQUEST:
    'product/GET_PRODUCT_ALL_FULFILLMENT_LIST_EXCEL_DOWNLOAD_REQUEST',
  getProductAllFulfillmentListExcelDownload: createAction(
    'product/GET_PRODUCT_ALL_FULFILLMENT_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  상품 일괄 편집을 하기전 유효성 테스트 결과 가져오기
   */
  GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_REQUEST: 'product/GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_REQUEST',
  GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_SUCCESS: 'product/GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_SUCCESS',
  getBulkEditProductValidateResultList: createAction('product/GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_REQUEST'),

  /**
   *  상품 일괄 편집하기
   */
  BULK_EDIT_PRODUCT_REQUEST: 'product/BULK_EDIT_PRODUCT_REQUEST',
  bulkEditProduct: createAction('product/BULK_EDIT_PRODUCT_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'product/TOGGLE_MODAL',
  toggleModal: createAction('product/TOGGLE_MODAL'),
};

export default actions;
